import {useTranslation} from "../../../hooks/useTranslation";

export default function UserSelectBranch({user, companyBranchId, setCompanyBranchId}) {
    const { t } = useTranslation();

    return (
        <>
            {user?.current_branches_persons?.length > 1 && (
                <div className="mb-10">
                    <label htmlFor="formPobocka" className="required form-label">
                        {t("common.company_branch")}
                    </label>

                    <select className="form-select form-select-solid form-select-sm"
                            defaultValue={companyBranchId}
                            required={true}
                            onChange={(e) => setCompanyBranchId(e.target.value)}
                    >
                        {user.current_branches_persons.map(branchPerson=>(
                            <option value={branchPerson.company_branch_id}>
                                {branchPerson.company_branch_name}
                            </option>
                        ))}
                    </select>
                </div>
            )}
        </>
    )
}